import { SCOPE_TYPE } from "@model";

export type TestMode = "single" | "session";

const STORAGE_KEY = "preferredTestMode";
export const TEST_MODE_SELECTION_URL = "/new-test";

export function getPreferredTestMode(): TestMode {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "session" ? "session" : "single";
}

export function setPreferredTestMode(mode: TestMode): void {
  localStorage.setItem(STORAGE_KEY, mode);
}

export function getPreferredTestModeUrl(): string {
  return TEST_MODE_SELECTION_URL;
}

export function getTestModeDestination(mode: TestMode, scopes?: string[]): string {
  if (mode === "session" && scopes?.includes(SCOPE_TYPE.testSession)) {
    return "/test-suite";
  }
  return "/new-test-ui";
}
